export const title = 'Downloads desde o início';

Quantidade total de instalações do app desde o lançamento dele.
